import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
/** 门店选择器前缀图标（侧栏与菜单库顶栏共用），与商家提议统一为 round-store 造型 */
import { ReactComponent as RestaurantMenu } from '../../static/images/svg/ic_round-store.svg';
import { ReactComponent as ArrowIcon } from '../../static/images/svg/iconamoon_arrow-up-2-fill.svg';
import { SelectOption } from '../form/base-input.component';
import { Restaurant } from '../../models';
import { Button, Typography } from '@mui/material';
import i18n from '../../i18n';
import './select-restaurant-list.scss';

export default function SelectRestaurantList(props: Readonly<{
    currentRestaurant: Restaurant;
    items: SelectOption[];
    value: string;
    onChange: (value: string) => void;
    style?: React.CSSProperties;
    isHiddenText?: boolean;
    /** 菜单库顶栏大样式（Figma 351:5398）：480×80、圆角 16、「当前餐厅：」前缀 */
    menuLibraryTopBar?: boolean;
    /** 根节点额外 class（如与顶栏样式组合） */
    className?: string;
}>) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const [selectedIndex, setSelectedIndex] = React.useState(props.value);

    React.useEffect(() => {
        setSelectedIndex(props.value)
    }, [props.value])

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (
        value: string,
    ) => {
        setSelectedIndex(value);
        setAnchorEl(null);
        props.onChange(value)
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const rootClass = [
        'select-restaurant-list',
        props.menuLibraryTopBar ? 'select-restaurant-list--menu-library-bar' : '',
        props.className ?? '',
    ]
        .filter(Boolean)
        .join(' ');
    /** 选择器宽度：默认侧栏 208px，隐藏文案时只保留图标宽度。 */
    let buttonWidth = '208px';
    if (props.isHiddenText) {
        buttonWidth = '50px';
    } else if (props.menuLibraryTopBar) {
        buttonWidth = 'auto';
    }

    return (
        <div style={props.style} className={rootClass}>
            <Button
                onClick={handleClick}
                variant="contained"
                endIcon={props.isHiddenText ? undefined : <ArrowIcon />}
                className="select-restaurant-list-btn"
                sx={{
                    width: buttonWidth,
                }}
            >
                <RestaurantMenu />
                {!props.isHiddenText && (
                    <Typography
                        variant={props.menuLibraryTopBar ? 'body1' : 'body2'}
                        component="span"
                        className={
                            props.menuLibraryTopBar
                                ? 'select-restaurant-list-btn__label'
                                : undefined
                        }
                    >
                        {props.menuLibraryTopBar ? (
                            <>
                                <span className="select-restaurant-list-btn__prefix">
                                    {i18n.t('menu_library_top_bar_current_restaurant_prefix')}
                                </span>
                                {props.currentRestaurant.nickname || '—'}
                            </>
                        ) : (
                            props.currentRestaurant.nickname
                        )}
                    </Typography>
                )}
            </Button>


            <Menu
                id='lock-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'lock-button',
                    role: 'listbox',
                }}
            >
                {props.items?.map((option) => (
                    <MenuItem
                        key={option.value}
                        selected={option.value === selectedIndex}
                        onClick={() => handleMenuItemClick(`${option.value}`)}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}
